export function isDEV() {
  return __DEV__
}
